import Keyboards from 'components/Keyboards/Keyboards'

export default Keyboards
